<template>
    <table class="table_wrapper">
        <thead class="table_head">
            <th class="table_th">{{$t('club.球员')}}</th>
            <th class="table_th" v-for="item in columns" :key="item.id">
                <span class="table_th_name">{{item['name' + $lang]}}</span>
            </th>
        </thead>

        <tbody class="table_body">
            <tr class="table_tr" v-for="(item, index) in rows" :key="item.id">
                <td class="table_td">{{item}}</td>
                <td class="table_td" v-for="(column, columnIndex) in columns" :key="column.id">
                    <slot v-bind="{row: item, column: column, data: data[columnIndex][index], rowIndex: index}">
						{{data[columnIndex][index]}}
					</slot>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
	/**
	 * ComponentName: cl-matrix
	 * Created Date: 2022/10/17
	 * Author: zhangjun
	 * 组件说明：矩阵组件，通过传入后端返回的行、列和数据渲染表格，展示数据可以通过slot传入。
	 * eg:	<cl-matrix
	 			:rows="matrixData.labelList"
                :columns="matrixData.playerList"
                :data="matrixData.matrix"
            >
                <template #default="{column, row, data, rowIndex}">
                    <span v-if="data" class="AkrobatM" @click="handlePlayVideo(column, row, isOdd = rowIndex % 2 === 0)">{{data}}</span>
                    <span v-else class="null_text">{{$nullText}}</span>
                </template>
            </cl-matrix>
	 */
    export default {
		name: 'cl-matrix',
        props: {
			// 矩阵行
			rows: {
				type: Array,
				default: () => ([]),
			},
            // 矩阵列
            columns: {
                type: Array,
                default: () => ([]),
            },
            // 矩阵数据
            data: {
                type: Array,
                default: () => ([]),
            }
        },

        data() {
            return {
                description: '矩阵组件',
            }
        },
    }
</script>

<style lang="scss" scoped>
    .table_wrapper {
        width: 100%;
        height: auto;
        th, td {
            border: 1px solid #e9edf3;
            font-size: 14px;
            line-height: 20px;
            font-family: SysFontM;
            color: $base-font-major;
        }
        .table_head {
            height: 50px;
            background: linear-gradient(270deg, #E4F7F4 0%, #EEF4FF 51.05%, #F7F0FF 100%);
            .table_th {
                padding-top: 12px;
                padding-bottom: 28px;
                vertical-align: middle;
                .table_th_name {
                    display: inline-block;
                    width: 1em;
                    line-height: 20px;
                }
            }
            .table_th:nth-of-type(1) {
                min-width: 150px;
                width: 50%;
            }
            .table_th:not(:nth-of-type(1)) {
                min-width: 50px;
            }
        }
        .table_body {
            .table_tr {
                height: 50px;
                text-align: center;
                .table_td {
                    vertical-align: middle;
                }
                .table_td:nth-of-type(1) {
                    min-width: 150px;
                    width: 50%;
                }
                .table_td:not(:nth-of-type(1)) {
                    min-width: 50px;
                    font-size: 18px;
                    line-height: 22px;
                }
                .null_text {
                    color: $base-font-tip;
                }
            }
        }
    }
    
</style>